<template>
  <div style="height:643px">
    <div :style="image">
      <span class="title2">
        服务支持
      </span>
    </div>
  </div>

  <div class="div2">
    <span class="content1">自助服务</span>

  </div>

  <div style="display:flex; justify-content:center; ">
    <div class="div3">
      <div class="div4"
           @click="goPage('repair')">
        <img src="../assets/images/repair1.png"
             style="margin-top:40px">
        <p class="content2">保修政策</p>
      </div>
      <div class="div4"
           @click="goPage('shop')">
        <img src="../assets/images/service1.png"
             style="margin-top:40px;">
        <p class="content2">服务门店查询</p>
      </div>

    </div>

  </div>

  <div style="display:flex; justify-content:center; margin-bottom:100px">
    <div class="div3">
      <div class="div4"
           @click="goPage('problems')">
        <img src="../assets/images/problems1.png"
             style="margin-top:40px">
        <p class="content2">常见问题</p>
      </div>

      <div class="div4"
           @click="goPage('query')">
        <img src="../assets/images/price1.png"
             style="margin-top:35px;width:96px">
        <p class="content2">备件价格查询</p>
      </div>

    </div>

  </div>
</template>

<script>


export default ({

  data () {
    return {
      image: {
        height: '643px',
        position: 'relative',
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url(' + require('../assets/images/service.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPositionY: '30%',
      }
    }

  },
  methods: {
    goPage (path) {
      this.$router.push({ name: path });
      window.scrollTo(0, 0);
    },
  }



})
</script>


<style scoped>
.image {
  height: 643px;
  position: relative;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/images/service.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 30%;
}

.title2 {
  font-size: 48px;
  font-style: SourceHanSansSC-bold;
  color: black;
  text-decoration: none;
  position: absolute;
  top: 45%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  color: white;
  font-weight: bold;
}

.div2 {
  text-align: center;
  margin-top: 100px;
}

.content1 {
  font-style: SourceHanSansSC-bold;
  font-size: 40px;
  color: #101010 100%;
  font-weight: bold;
}

.div3 {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  width: 800px;
}

.div4 {
  background-color: #f5f5f5;
  width: 380px;
  height: 240px;
  cursor: pointer;
  /* margin: 0 auto; */
}

.content2 {
  font-size: 20px;
  font-style: SourceHanSansSC-regular;
  color: #101010 100%;
}
</style>
